class JapaSiteHeader extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.header = this.querySelector('.jw-header');
    this.scrollSurface = this.closest('.page-wrapper') || window;
    const scrollPosition = () => Math.max(0,window.scrollY,this.scrollSurface === window ? 0 : this.scrollSurface.scrollTop);
    this.lastY = scrollPosition();
    this.travel = 0;
    this.direction = 0;
    const options = {signal:this.controller.signal};
    const reveal = () => this.removeAttribute('data-hidden');
    this.resize = new ResizeObserver(() => {
      const height = this.header.getBoundingClientRect().height;
      this.style.setProperty('--jw-nav-height',height+'px');
      document.documentElement.style.scrollPaddingTop = (height+20)+'px';
      if(this.scrollSurface !== window)this.scrollSurface.style.scrollPaddingTop = (height+20)+'px';
    });
    this.resize.observe(this.header);
    this.setAttribute('data-ready','');
    window.addEventListener('scroll', event => {
        if(event.target !== this.scrollSurface && event.target !== document)return;
        const y = scrollPosition(),delta=y-this.lastY;
        this.lastY=y;
        if (!delta) return;
        const direction=Math.sign(delta);
        this.travel=direction===this.direction?this.travel+Math.abs(delta):Math.abs(delta);
        this.direction=direction;
        if (y<=this.header.offsetHeight || this.querySelector('details[open]') || this.header.querySelector(':focus-visible')) { reveal(); return; }
        if (direction<0 && this.travel>8) reveal();
        if (direction>0 && this.travel>16) this.setAttribute('data-hidden','');
    },{...options,passive:true,capture:true});
    this.addEventListener('focusin',reveal,options);
    this.addEventListener('keydown',event=>{
      if(event.key!=='Escape')return;
      const open=[...this.querySelectorAll('details[open]')].reverse()[0];
      if(open){open.open=false;open.querySelector('summary').focus();event.preventDefault();}
    },options);
    this.addEventListener('click',event=>{
      if(event.target.closest('a'))this.closeMenus();
    },options);
    document.addEventListener('click',event=>{if(!this.contains(event.target))this.closeMenus();},options);
    window.addEventListener('pageshow',reveal,options);
  }
  closeMenus(){for(const menu of this.querySelectorAll('details[open]'))menu.open=false;}
  disconnectedCallback(){this.controller?.abort();this.resize?.disconnect();if(this.frame)cancelAnimationFrame(this.frame);}
}
if(!customElements.get('japa-site-header'))customElements.define('japa-site-header',JapaSiteHeader);
